import { createTheme, Palette, Theme } from '@mui/material';
import { red } from '@mui/material/colors';

interface IPalette extends Palette {
  custom: {
    opaqueBackground: string;
    opaqueWhite: string;
    opaqueRed: string;
    opaqueBlue: string;
    opaqueBlack: string;
  };
}

interface ITheme extends Theme {
  palette: IPalette;
}

// Create a theme instance.
export const theme = createTheme({
  typography: {
    fontFamily: `Verdana, Helvetica, sans-serif, Arial`,
    fontSize: 16,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
  },
  palette: {
    background: { default: '#E8E8E8' },
    custom: {
      opaqueBackground: 'rgba(232, 232, 232, 0.9)',
      opaqueWhite: 'rgba(232, 232, 232, 0.4)',
      opaqueRed: 'rgba(238, 50, 32, 0.8)',
      opaqueBlue: 'rgba(42, 57, 152, 0.8)',
      opaqueBlack: 'rgba(0,0,0, 0.8)',
    },
    primary: {
      main: '#2A3998',
      contrastText: '#000',
    },
    secondary: {
      main: '#fff',
      contrastText: '#EE3220',
    },
    error: {
      main: red.A400,
    },
  },
} as ITheme);
